"use client";

import {
  Product,
  ProductEdition,
} from "../../../.storyblok/types/287059/storyblok-components";
import { useMatchingLocaleContext } from "../../helpers/LocaleStringContext";
import { getProductVersionContainsSugar } from "../../helpers/getProductVersionContainsSugar";
import { CosmosText } from "@cosmos/web-react";
import classNames from "classnames/bind";
import styles from "./LegalDisclaimerBannerRussia.module.css";

const cx = classNames.bind(styles);

const sugarCopy = (
  <>
    <CosmosText size="x-small" kind="subtle">
      не рекомендуется для детей в случаях, предусмотренных законодательством
      РФ.
    </CosmosText>
    <CosmosText size="x-small" kind="subtle">
      Energy Drink – энергетический напиток
    </CosmosText>
    <CosmosText size="x-small" kind="subtle">
      Оригинал товара может отличаться от его изображения
    </CosmosText>
  </>
);

const sugarfreeCopy = (
  <>
    <CosmosText size="x-small" kind="subtle">
      не рекомендуется для детей в случаях, предусмотренных законодательством
      РФ.
    </CosmosText>
    <CosmosText size="x-small" kind="subtle">
      Sugarfree – без сахара
    </CosmosText>
    <CosmosText size="x-small" kind="subtle">
      Оригинал товара может отличаться от его изображения
    </CosmosText>
  </>
);

const bothCopy = (
  <>
    <CosmosText size="x-small" kind="subtle">
      не рекомендуется для детей в случаях, предусмотренных законодательством
      РФ.
    </CosmosText>
    <CosmosText size="x-small" kind="subtle">
      Energy Drink – энергетический напиток
    </CosmosText>
    <CosmosText size="x-small" kind="subtle">
      Sugarfree – без сахара
    </CosmosText>
    <CosmosText size="x-small" kind="subtle">
      Оригинал товара может отличаться от его изображения
    </CosmosText>
  </>
);

type RedBullVersion =
  Product["redBullVersion"] | ProductEdition["redBullVersion"];

/**
 * Pages without a product (FAQ, index pages, …) have to cover both variants.
 */
const getCopy = (redBullVersion?: RedBullVersion) => {
  if (redBullVersion === undefined) {
    return bothCopy;
  }

  return getProductVersionContainsSugar(redBullVersion)
    ? sugarCopy
    : sugarfreeCopy;
};

export const LegalDisclaimerBannerRussia = ({
  redBullVersion,
}: {
  redBullVersion?: RedBullVersion;
}) => {
  const matchingLocale = useMatchingLocaleContext();

  if (matchingLocale?.legalDisclaimer !== "ru") {
    return null;
  }

  return (
    <div className={cx("container")}>
      <div className={cx("inner")}>{getCopy(redBullVersion)}</div>
    </div>
  );
};
